import React from 'react'
import LessThan1680 from './LessThan1680'
import LessThan1280 from './LessThan1280'
import LessThan960 from './LessThan960'
import LessThan760 from './LessThan760'
import LessThan600 from './LessThan600'
import BiggerThan1680 from './BiggerThan1680'
import styled from 'styled-components'
import * as media from '../../media'

const LessThan600Check = styled.div`
  ${media.biggerThan(701)`display:none;`}
`

const LessThan760Check = styled.div`
  ${media.biggerThan(760)`display:none;`}
  ${media.smallerThan(700)`display:none;`}
`

const LessThan960Check = styled.div`
  ${media.biggerThan(1071)`display:none;`}
  ${media.smallerThan(760)`display:none;`}
`

const LessThan1280Check = styled.div`
  ${media.biggerThan(1355)`display:none;`}
  ${media.smallerThan(1070)`display:none;`}  
`

const LessThan1680Check = styled.div`
  ${media.biggerThan(1680)`display:none;`}
  ${media.smallerThan(1354)`display:none;`}  
`

const BiggerThan1680Check = styled.div`
  ${media.smallerThan(1680)`display:none;`}
`

const Amort = (props) => {
  return (
    <div style={{marginRight: '-10%'}}>
      <LessThan600Check>
        <LessThan600 {...props} />
      </LessThan600Check>
      <LessThan760Check>
        <LessThan760 {...props} />
      </LessThan760Check>
      <LessThan960Check>
        <LessThan960 {...props} />
      </LessThan960Check>
      <BiggerThan1680Check>
        <BiggerThan1680 {...props} />
      </BiggerThan1680Check>
      <LessThan1680Check>
        <LessThan1680 {...props} />
      </LessThan1680Check>
      <LessThan1280Check>
        <LessThan1280 {...props} />
      </LessThan1280Check>
    </div>
  )
}

export default Amort




// WEBPACK FOOTER //
// ./src/finwhale/amort/index.js